import {connect} from "react-redux";
import Raildays from "Helpers/Raildays.js";

export default Component => {

	return connect(({raildays}) => ({raildays: (raildays || Raildays.active)}))(Component);

};
